import I18n from 'i18n-js';
import React, { useState } from 'react';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { RCButtonLink, RCCallout } from '@reverbdotcom/cadence/components';
import { ProtectionShieldIcon } from '@reverbdotcom/cadence/icons/react';

import { Paths } from '../components/shared/url_helpers';

export function TruliooIdentityVerificationBanner() {
  const [isDismissed, setIsDismissed] = useState(false);

  const identityVerificationPath = Paths.coreIdentityVerification.expand({});

  if (isDismissed) { return null; }

  return (
    <div className="mt-8">
      <RCCallout
        themeType="utility"
        variant="loud-ultralight"
        border="thin"
        icon={<ProtectionShieldIcon />}
        title={I18n.t('discovery.truliooIdentityVerificationBanner.title')}
        onDismiss={() => setIsDismissed(true)}
        cta={(
          <RCButtonLink
            variant="filled"
            renderLink={c => <CoreLink to={identityVerificationPath} target="_blank">{c}</CoreLink>}
          >
            {I18n.t('discovery.truliooIdentityVerificationBanner.verifyNow')}
          </RCButtonLink>
        )}
      >
        <p className="mb-0">
          {I18n.t('discovery.truliooIdentityVerificationBanner.message')}
        </p>
      </RCCallout>
    </div>
  );
}

export default TruliooIdentityVerificationBanner;
